import * as React from 'react'
import * as Styles from './floatCoupon.style'
import { HttpServer } from '@/services/server'
import globalBus from '@/services/Bus'
import { reportViewEvent, reportClickEvent } from '@weike/operation-report'

interface ConfigValue {
  enabled: boolean // 开关字段，控制是否显示组件
  jump_url: string // 点击跳转链接
  text_config: {
    content: string // 文字内容，支持HTML标签
    color: string // 默认文字颜色
  }
  left_image?: string // 左侧图片URL，可选
  right_text?: string // 右侧文字，可选
  right_image?: string // 右侧图片URL，可选
  background_color?: string // 背景颜色，可选
  height?: number // 组件高度，可选
}

interface FloatCouponState {
  config: ConfigValue | null
  isShow: boolean
}

export default class FloatCoupon extends React.PureComponent<{}, FloatCouponState> {
  constructor(props: {}) {
    super(props)
    this.state = {
      config: null,
      isShow: false
    }
  }

  public async componentDidMount() {
    try {
      const { data: { data } } = await HttpServer.getWhitelistConfigs({
        keys: 'homepage_top_resource',
        version: '1.0',
        server_name: 'weike'
      })

      const configItem = data.find((item: any) => item.key === 'homepage_top_resource')

      // 如果配置项存在，并且enabled为true，并且jump_url不为空，则显示组件
      if (configItem && configItem.value.enabled && configItem.value.jump_url) {
        this.setState({
          config: configItem.value,
          isShow: true
        }, () => {
          // 发送展示埋点
          this.sendReport('show_top_coupon')
          globalBus.emit({isShowTopCouponTips: 'true'})
        })
      }
    } catch (error) {
      console.log('error', error)
    }
  }

  public sendReport(evt: 'show_top_coupon_click' | 'show_top_coupon') {
    if (evt === 'show_top_coupon') {
      reportViewEvent('top_advertisement', {object_type: 'coupon_bag', object_id: 'homepage_top_resource'})
    } else {
      reportClickEvent('top_advertisement', {object_type: 'coupon_bag', object_id: 'homepage_top_resource'})
    }
  }

  public getLink = () => {
    const { config } = this.state
    if (!config) { return }

    this.sendReport('show_top_coupon_click')
    setTimeout(() => {
      window.location.assign(config.jump_url)
    }, 150)
  }

  public render() {
    const { config, isShow } = this.state

    if (!isShow || !config) {
      return null
    }

    // 动态样式
    const dynamicStyles = {
      background: config.background_color || 'linear-gradient(270deg, #DAC888 1%, #EFDCA4 100%)',
      height: config.height || 40
    }

    return (
      <div className={Styles.FloatCoupon} style={dynamicStyles} onClick={this.getLink}>
        <div className={Styles.FloatCouponArea}>
          {/* 左侧图片 */}
          <div className={Styles.FloatCouponAreaLeftArea}>
            {config.left_image && (
              <img
                className={Styles.FloatCouponAreaImg}
                src={config.left_image}
                alt="coupon"
              />
            )}
            {/* 中间文字，支持HTML和颜色配置 */}
            <div
              className={Styles.sampleText}
              style={{ color: config.text_config.color || '#685417' }}
              dangerouslySetInnerHTML={{ __html: config.text_config.content }}
            />
          </div>

          {/* 右侧文字和图片 */}
          <div className={Styles.FloatCouponAreaRightArea}>
            <p style={{ color: config.text_config.color || '#685417' }}>{config.right_text || '立即领取'}</p>
            <img src={config.right_image || 'https://static-cos.lycheer.net/picture/12209467_fcb901f5af3ea9440696ef18f209e3af.jpg'} alt="arrow"/>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/plugins/coupon/floatCoupon.tsx